
import React from 'react'
import LeaveApplicationListTable from './Components/LeaveApplicationListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const LeaveApplicationList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Leave Application List</HeadingOne>
                    <AddItemBtn url="add-leave-application" title="Add Application" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <LeaveApplicationListTable />
            </div>
        </PageBody>
    );
};

export default LeaveApplicationList;
